<template>
  <div class="home-page home-redesign-page" :class="{ 'is-burmese': $i18n.locale === 'bur' }">
    <main class="home-redesign-content">
      <header class="home-redesign-header">
        <div class="home-redesign-logo" aria-label="Go Quiz">
          <img src="../../static/images/home/logo.png" alt="Go Quiz">
        </div>
        <button class="home-redesign-avatar" type="button" :aria-label="$t('Settings')" @click="getToNav('myAccount')">
          <img :src="info.avatar" alt="">
        </button>
        <div class="home-redesign-stat" aria-label="Points">
          <img src="../../static/images/home/pts.png" alt="">
          <strong>{{ info.points || 0 }}</strong>
        </div>
        <button class="home-redesign-stat home-redesign-chance" type="button" @click="getSub">
          <img src="../../static/images/home/chance.png" alt="">
          <strong>{{ info.score || 0 }}</strong>
          <img class="home-redesign-plus" src="../../static/images/home/plus.png" alt="+">
        </button>
        <button class="home-redesign-settings" type="button" :aria-label="$t('Settings')" @click="getToNav('myAccount')">
          <img src="../../static/images/home/settings.png" alt="">
        </button>
      </header>

      <button class="home-redesign-banner" type="button" @click="getToNav('liveQuizList')">
        <img src="../../static/images/home/quiz_ulti_banner.png" alt="Quiz Ultimate">
        <span class="home-redesign-next-match">
          <img src="../../static/images/home/quiz_ulti_banner_txt_bg.png" alt="">
          <strong>{{ $t('LiveQuizNextMatch', {time: nextMatchCountdown}) }}</strong>
        </span>
      </button>

      <button ref="categoryControl" class="home-redesign-category" type="button" @click="toggleCategories">
        <img class="home-redesign-category-bg" src="../../static/images/home/category_bg.png" alt="">
        <img class="home-redesign-category-icon" src="../../static/images/home/category_icon.png" alt="">
        <strong>{{ $t('Categories') }}</strong>
        <span class="home-redesign-category-select">
          <img src="../../static/images/home/choose_one_bg.png" alt="">
          <em>{{ selectedCategoryName }}</em>
          <img class="home-redesign-category-arrow" :src="isChooseShow ? '../../static/images/home/up_arrow.png' : '../../static/images/home/drop_arrow.png'" alt="">
        </span>
      </button>

      <section class="home-redesign-cards" :aria-label="$t('Categories')">
        <button class="home-redesign-card" type="button" @click="goBattleRoom('quizCenter')">
          <img class="home-redesign-card-art" src="../../static/images/home/quiz_center.png" alt="">
          <span class="home-redesign-card-copy home-redesign-quiz-copy">
            <img src="../../static/images/home/quiz_center_txt_bg.png" alt="">
            <strong>{{ $t('homeGame2T') }}</strong>
            <em>{{ $t('homeGame2C') }}</em>
          </span>
        </button>
        <button class="home-redesign-card" type="button" @click="goBattleRoom('gameList')">
          <img class="home-redesign-card-art" src="../../static/images/home/brain_games.png" alt="">
          <span class="home-redesign-card-copy home-redesign-brain-copy">
            <img src="../../static/images/home/brain_games_txt_bg.png" alt="">
            <strong>{{ $t('homeGame1T') }}</strong>
            <em>{{ $t('homeGame1C') }}</em>
          </span>
        </button>
      </section>

      <section class="home-redesign-actions">
        <button type="button" @click="getToNav('invitation')">
          <img src="../../static/images/home/invite_friends.png" alt="">
          <span>{{ $t('invitation') }}</span>
        </button>
        <button type="button" @click="getSub">
          <img src="../../static/images/home/buy_more_chances.png" alt="">
          <span>{{ $t('BuyChances') }}</span>
        </button>
      </section>
    </main>

    <nav class="home-redesign-nav" aria-label="Primary">
      <img class="home-redesign-nav-bg" src="../../static/images/home/nevigator_bg.png" alt="">
      <button :class="{ 'is-current': activeNav === 'rank' }" type="button" @click="navigateFromBottom('rank')">
        <img v-if="activeNav === 'rank'" class="home-redesign-nav-active" src="../../static/images/home/nevigator_menu_act.png" alt="">
        <img src="../../static/images/home/rank.png" alt="">
        <span>{{ $t('Ranking') }}</span>
      </button>
      <button :class="{ 'is-current': activeNav === 'home' }" type="button" :aria-current="activeNav === 'home' ? 'page' : null" @click="navigateFromBottom('home')">
        <img v-if="activeNav === 'home'" class="home-redesign-nav-active" src="../../static/images/home/nevigator_menu_act.png" alt="">
        <img src="../../static/images/home/home_act.png" alt="">
        <span>{{ $t('LiveQuizHome') }}</span>
      </button>
      <button :class="{ 'is-current': activeNav === 'prizes' }" type="button" @click="navigateFromBottom('prizes')">
        <img v-if="activeNav === 'prizes'" class="home-redesign-nav-active" src="../../static/images/home/nevigator_menu_act.png" alt="">
        <img src="../../static/images/home/prize.png" alt="">
        <span>{{ $t('HomeNavPrizes') }}</span>
      </button>
    </nav>
    <div class="home-category-overlay" v-if="isChooseShow">
      <div class="home-category-overlay-mask" @click="toggleCategories"></div>
      <section class="home-category-panel" :style="{ top: categoryPanelTop + 'px' }" :aria-label="$t('Categories')">
        <img class="home-category-panel-bg" src="../../static/images/home/category_big_bg.png" alt="">
        <div class="home-category-options">
          <button
            v-for="item in categoryOptions"
            :key="item.id"
            class="home-category-option"
            :class="{ 'is-selected': String(isSelect) === String(item.id) }"
            type="button"
            @click="clickSelect(item.id)"
          >
            <img class="home-category-option-bg" :src="String(isSelect) === String(item.id) ? '../../static/images/home/category_act.png' : '../../static/images/home/category_normal_bg.png'" alt="">
            <img class="home-category-option-art" :src="categoryImage(item)" alt="">
            <span>{{ item.name }}</span>
            <img v-if="String(isSelect) === String(item.id)" class="home-category-option-selected" src="../../static/images/home/Selected.png" alt="">
          </button>
        </div>
      </section>
    </div>
    <div class="buy-more-popup" v-if="showBuyMorePopup">
      <div class="buy-more-popup-mask" @click="closeBuyMorePopup"></div>
      <section class="buy-more-popup-dialog" role="dialog" aria-modal="true" :aria-label="$t('BuyChances')">
        <div class="buy-more-popup-header">
          <img src="../../static/images/buy_more/pop_up_header.png" alt="">
          <h2>{{ $t('BuyChances') }}</h2>
        </div>
        <div class="buy-more-popup-card">
          <img class="buy-more-popup-card-bg" src="../../static/images/buy_more/buy_chance_pop_up_bg.png" alt="">
          <div class="buy-more-popup-content">
            <p>
              <span class="buy-more-popup-copy-lead">{{ $t('BuyMoreChancesCopy') }}</span>
              <span class="buy-more-popup-copy-reward">{{ $t('BuyMoreChancesWin') }} <strong>{{ $t('BuyMoreChancesHighlight') }}</strong></span>
            </p>
            <img class="buy-more-popup-hero" src="../../static/images/buy_more/buy_chance_photo.png" alt="">
            <div class="buy-more-popup-options">
              <button type="button" @click="startSub('daily')">
                <img class="buy-more-popup-option-bg" src="../../static/images/buy_more/chance_bg.png" alt="">
                <img src="../../static/images/buy_more/daily.png" :alt="$t('Daily')">
                <span>{{ $t('Daily') }}</span>
              </button>
              <button type="button" @click="startSub('weekly')">
                <img class="buy-more-popup-option-bg" src="../../static/images/buy_more/chance_bg.png" alt="">
                <img src="../../static/images/buy_more/weekly.png" :alt="$t('Weekly')">
                <span>{{ $t('Weekly') }}</span>
              </button>
              <button type="button" @click="getSubmit">
                <img class="buy-more-popup-option-bg" src="../../static/images/buy_more/chance_bg.png" alt="">
                <img src="../../static/images/buy_more/one_time_purchase.png" :alt="$t('one_time_purchase')">
                <span>{{ $t('one_time_purchase') }}</span>
              </button>
            </div>
            <div class="buy-more-popup-balance">
              <span>{{ $t('CurrentChances') }}</span>
              <img src="../../static/images/home/chance.png" alt="">
              <strong>{{ info.score || 0 }}</strong>
            </div>
          </div>
        </div>
        <button class="buy-more-popup-close" type="button" :aria-label="$t('Later')" @click="closeBuyMorePopup">
          <img src="../../static/images/buy_more/close.png" alt="">
        </button>
      </section>
    </div>
    <div class="announcement-popup" v-if="showAnnouncementPopup">
      <div class="announcement-popup-mask" @click="closeAnnouncementPopup"></div>
      <div class="announcement-popup-dialog" role="dialog" aria-modal="true" aria-labelledby="announcement-title">
        <div class="announcement-popup-card">
          <img class="announcement-popup-bg" src="../../static/images/popup/pop_up_bg.png" alt="">
          <div class="announcement-popup-content">
            <div class="announcement-popup-title-wrap">
              <img src="../../static/images/popup/pop_up_title_bg.png" alt="">
              <h2 id="announcement-title">{{ $t('AnnouncementPopupTitle') }}</h2>
            </div>
            <div class="announcement-popup-copy-wrap">
              <img src="../../static/images/popup/pop_up_txt_bg.png" alt="">
              <p>{{ $t('AnnouncementPopupContent') }}</p>
            </div>
            <img class="announcement-popup-prize" src="../../static/images/popup/pop_up_prize.png" alt="Grand prizes">
            <button class="announcement-popup-action" type="button" @click="closeAnnouncementPopup">
              <img src="../../static/images/popup/pop_up_btn.png" alt="">
              <span>{{ $t('AnnouncementPopupAction') }}</span>
            </button>
          </div>
        </div>
        <button class="announcement-popup-close" type="button" :aria-label="$t('AnnouncementPopupClose')" @click="closeAnnouncementPopup">×</button>
      </div>
    </div>
    <div class="football-popup" v-if="showFootballPopup">
      <div class="football-popup-mask" @click="closeFootballPopup"></div>
      <div class="football-popup-dialog">
        <div class="football-popup-card">
          <img class="football-popup-image" :src="footballPopupImage" alt="football popup">
          <button class="football-popup-action" @click="handleFootballPopupClick">
            <img :src="footballPopupButtonImage" alt="football popup button">
          </button>
        </div>
        <button class="football-popup-close" @click="closeFootballPopup">x</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShow: null,
      isEN: 'bur',
      mobile: '',
      otp: '',
      codeText: '',
      isReturn: false,
      chooseList: [
        {id: 0, name: 'Random'},
        {id: 'music', name: 'Musics'},
        {id: 'movies', name: 'Movies'},
        {id: 'countries', name: 'Countries'},
        {id: 'sports', name: 'Sports'}
      ],
      showAnnouncementPopup: false,
      showFootballPopup: false,
      isSelect: false,
      isChooseShow: false,
      info: {},
      showBuyMorePopup: false,
      marquee: [],
      nextLiveRound: null,
      nextLiveRoundReceivedAt: 0,
      nextMatchNow: Date.now(),
      nextMatchTimer: null,
      activeNav: 'home',
      categoryPanelTop: 0,
    }
  },
  computed: {
    isMyanmarLang() {
      return (this.isEN || 'bur') === 'bur'
    },
    footballBannerImage() {
      return this.isMyanmarLang
        ? '../../static/images/football/football_index_banner_mm.png'
        : '../../static/images/football/football_index_banner.png'
    },
    footballPopupImage() {
      return this.isMyanmarLang
        ? '../../static/images/football/football_index_pop_up_mm.png'
        : '../../static/images/football/football_index_pop_up.png'
    },
    footballPopupButtonImage() {
      return this.isMyanmarLang
        ? '../../static/images/football/footabll_index_pop_up_btn_mm.png'
        : '../../static/images/football/footabll_index_pop_up_btn.png'
    },
    selectedCategoryName() {
      const selected = (this.chooseList || []).find(item => String(item.id) === String(this.isSelect))
      return selected && selected.name ? selected.name : this.$t('ChooseHere')
    },
    nextMatchCountdown() {
      if (!this.nextLiveRound) return '--:--:--'
      const elapsed = Math.floor((this.nextMatchNow - this.nextLiveRoundReceivedAt) / 1000)
      const total = Math.max(0, Number(this.nextLiveRound.start_countdown_seconds || 0) - elapsed)
      const hours = String(Math.floor(total / 3600)).padStart(2, '0')
      const minutes = String(Math.floor((total % 3600) / 60)).padStart(2, '0')
      const seconds = String(total % 60).padStart(2, '0')
      return hours + 'h ' + minutes + 'm ' + seconds + 's'
    },
    categoryOptions() {
      const orderedIds = ['0', '1', '2', '3', '4']
      return (this.chooseList || []).slice().sort((left, right) => {
        const leftIndex = orderedIds.indexOf(String(left.id))
        const rightIndex = orderedIds.indexOf(String(right.id))
        return (leftIndex === -1 ? 99 : leftIndex) - (rightIndex === -1 ? 99 : rightIndex)
      })
    }
  },
  created() {
    this.isEN = localStorage.getItem('lang')
    this.codeText = this.$t('getCode');
    this.initAnnouncementPopup()
    // this.initFootballPopup()
    this.getHome()
    this.nextMatchTimer = setInterval(() => {
      this.nextMatchNow = Date.now()
    }, 1000)
  },
  beforeDestroy() {
    if (this.nextMatchTimer) clearInterval(this.nextMatchTimer)
  },
  methods: {
    goBattleRoom(url) {
      if (this.info.score < 1) {
        this.showBuyMorePopup = true
        return;
      }
      this.$router.push({path: '/' + url});
    },
    getToNav(url) {
      this.$router.push({path: '/' + url});
    },
    navigateFromBottom(target) {
      this.activeNav = target
      if (target === 'home') return
      this.getToNav(target === 'prizes' ? 'prize' : 'rank')
    },
    toggleCategories() {
      this.isChooseShow = !this.isChooseShow
      if (!this.isChooseShow) return
      this.$nextTick(() => {
        const control = this.$refs.categoryControl
        if (!control) return
        const rect = control.getBoundingClientRect()
        this.categoryPanelTop = Math.max(16, Math.round(rect.bottom + 18))
      })
    },
    categoryImage(item) {
      const name = String((item && item.name) || '').toLowerCase()
      const id = String(item && item.id)
      if (id === '0' || name.indexOf('random') !== -1) return '../../static/images/home/category_random.png'
      if (id === '1' || name.indexOf('music') !== -1) return '../../static/images/home/category_musics.png'
      if (id === '2' || name.indexOf('movie') !== -1) return '../../static/images/home/category_movies.png'
      if (id === '3' || name.indexOf('countr') !== -1 || name.indexOf('travel') !== -1) return '../../static/images/home/category_countries.png'
      if (id === '4' || name.indexOf('sport') !== -1) return '../../static/images/home/category_sports.png'
      return item && item.image ? item.image : '../../static/images/home/category_random.png'
    },
    clickSelect(item) {
      let that = this
      if (String(that.isSelect) === String(item)) return
      that.isSelect = item
      that.$parent.loadModal(true);
      let data = {
        "question_type_id": item
      }
      that.$api.post('/api/index/select_question_type', data, r => {
        that.$parent.loadModal(false);
        that.$utils.alertText(r.msg, 80);
        return;
      })
    },
    getHome() {
      this.getUserInfo();
      this.getQuestionType();
      this.getMarquee();
      this.getNextLiveRound();
    },
    getUserInfo() {
      let that = this;
      that.$api.get('/api/user/info', null, r => {
        that.$parent.returnCode(r, function () {
          that.info = r.data
        });
      })
    },
    getQuestionType() {
      let that = this;
      that.$api.get('/api/index/question_type', null, r => {
        that.$parent.returnCode(r, function () {
          that.chooseList = r.data.question_type
          that.isSelect = r.data.user_type_id
        });
      })
    },
    closeBuyMorePopup() {
      this.showBuyMorePopup = false
    },
    getSubmit() {
      let that = this
      that.$parent.loadModal(true);
      that.$api.post('/api/index/buy', null, r => {
        that.$parent.returnCode(r, function () {
          that.$parent.loadModal(false);
          if (r.code == 1) {
            that.closeBuyMorePopup();
            that.$utils.alertText(r.msg, 80, 800);
            that.getUserInfo();
          } else {
            that.$utils.alertText(r.msg, 80, 3000);
          }
        });
      })
    },
    startSub(type){
      //有号码直接订阅登录
      let that = this
      that.$parent.loadModal(true);
      let mobile = that.info.mobile
      let url = '/api/user/sub?mobile='+mobile +'&type='+type
      that.$api.get(url, {},r =>{
        that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);
          that.$utils.alertText(r.msg,80, 3000);
        });
      })
    },
    getMarquee() {
      let that = this
      that.$api.post('/api/index/marquee', null, r => {
        that.$parent.returnCode(r, function () {
          if (r.code == 1) {
            that.marquee = r.data
          }
        });
      })
    },
    getNextLiveRound() {
      const applyRound = (list) => {
        const next = (list || []).find(item => {
          return item && item.status !== 'ended' && Number(item.start_countdown_seconds || 0) > 0
        })
        if (next) {
          this.nextLiveRound = next
          this.nextLiveRoundReceivedAt = Date.now()
          this.nextMatchNow = this.nextLiveRoundReceivedAt
        }
        return Boolean(next)
      }
      this.$api.get('/api/live_quiz/rounds', {period: 'today', page: 1, limit: 20}, r => {
        this.$parent.returnCode(r, () => {
          const data = r.data || {}
          if (applyRound(data.list)) return
          this.$api.get('/api/live_quiz/rounds', {period: 'tomorrow', page: 1, limit: 20}, nextResponse => {
            this.$parent.returnCode(nextResponse, () => {
              applyRound((nextResponse.data || {}).list)
            })
          })
        })
      })
    },
    getSub(type) {
      this.showBuyMorePopup = true
    },
    initAnnouncementPopup() {
      const popupKey = 'announcement_popup_last_show_time_v1'
      const popupInterval = 24 * 60 * 60 * 1000
      const now = Date.now()

      try {
        const lastShowTime = parseInt(localStorage.getItem(popupKey) || '0', 10)
        if (!lastShowTime || now - lastShowTime >= popupInterval) {
          this.showAnnouncementPopup = true
          localStorage.setItem(popupKey, String(now))
        }
      } catch (error) {
        this.showAnnouncementPopup = true
      }
    },
    closeAnnouncementPopup() {
      this.showAnnouncementPopup = false
    },
    initFootballPopup() {
      const popupKey = 'football_popup_last_show_time'
      const popupInterval = 6 * 60 * 60 * 1000
      const now = Date.now()
      const lastShowTime = parseInt(localStorage.getItem(popupKey) || '0', 10)
      if (!lastShowTime || now - lastShowTime >= popupInterval) {
        this.showFootballPopup = true
        localStorage.setItem(popupKey, String(now))
      }
    },
    closeFootballPopup() {
      this.showFootballPopup = false
    },
    handleFootballPopupClick() {
      this.closeFootballPopup()
      this.goFootballQuizPage()
    },
    goFootballQuizPage() {
      this.getToNav('footballQuiz')
    },
  }
}
</script>
<style scoped>
.home-page {
  min-height: 100vh;
  background: #080126 url('../../static/images/livequiz/main_bg.jpg') no-repeat center top !important;
  background-size: 100% auto !important;
}

.home-redesign-page {
  position: relative;
  isolation: isolate;
  overflow-x: hidden;
  padding: 42px 28px 278px;
  box-sizing: border-box;
  color: #fff;
  font-family: Arial, Atom-sans, sans-serif;
}

.home-redesign-page::before {
  position: fixed;
  z-index: -1;
  inset: 0;
  content: '';
  background: linear-gradient(180deg, rgba(11, 0, 38, .08), rgba(7, 0, 29, .72) 70%, rgba(14, 0, 33, .92));
  pointer-events: none;
}

.home-redesign-content,
.home-redesign-nav {
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
}

.home-redesign-header {
  display: grid;
  grid-template-columns: 1.15fr .96fr 1.64fr 1.9fr .78fr;
  gap: 10px;
  align-items: center;
  min-height: 118px;
}

.home-redesign-header button,
.home-redesign-banner,
.home-redesign-category,
.home-redesign-card,
.home-redesign-actions button,
.home-redesign-nav button {
  appearance: none;
  border: 0;
  padding: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.home-redesign-logo,
.home-redesign-avatar,
.home-redesign-settings { display: block; }
.home-redesign-logo img { display: block; width: 100%; max-width: 106px; margin: 0 auto; }
.home-redesign-avatar { width: 76px; height: 76px; overflow: hidden; justify-self: center; border: 3px solid #fff !important; border-radius: 50%; background: #ffbe21 !important; }
.home-redesign-avatar img { display: block; width: 100%; height: 100%; object-fit: cover; }
.home-redesign-settings img { display: block; width: 58px; max-width: 100%; margin: 0 auto; }

.home-redesign-stat {
  display: flex !important;
  align-items: center;
  justify-content: flex-start;
  min-width: 0;
  height: 56px;
  padding: 0 10px !important;
  border: 2px solid rgba(255,255,255,.84) !important;
  border-radius: 999px !important;
  background: rgba(19, 2, 58, .75) !important;
  box-shadow: inset 0 0 16px rgba(255,255,255,.08);
}

.home-redesign-stat > img:first-child { width: 39px; height: 39px; flex: none; object-fit: contain; }
.home-redesign-stat strong { overflow: hidden; margin-left: 8px; color: #fff; font-size: clamp(18px, 4.5vw, 34px); font-weight: 900; line-height: 1; text-overflow: ellipsis; white-space: nowrap; }
.home-redesign-chance { padding-right: 5px !important; }
.home-redesign-chance strong { flex: 1; }
.home-redesign-stat .home-redesign-plus { width: 39px; height: 39px; flex: none; margin-left: 4px; object-fit: contain; }

.home-redesign-banner { position: relative; display: block; width: 100%; margin-top: 26px; }
.home-redesign-banner > img { display: block; width: 100%; }
.home-redesign-next-match { position: absolute; right: .8%; bottom: 2.6%; width: 57%; }
.home-redesign-next-match img { display: block; width: 100%; }
.home-redesign-next-match strong { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; padding: 0 4%; color: #fff; font-size: clamp(12px, 3.15vw, 24px); font-style: italic; font-weight: 900; line-height: 1; text-shadow: 0 3px 4px rgba(35,0,17,.82); white-space: nowrap; }

.home-redesign-category { position: relative; display: flex; align-items: center; width: 100%; height: auto; margin-top: 28px; text-align: left; }
.home-redesign-category-bg { display: block; width: 100%; }
.home-redesign-category-icon { position: absolute; left: 4%; width: 11%; max-width: 82px; }
.home-redesign-category > strong { position: absolute; left: 18%; color: #fff; font-size: clamp(20px, 6vw, 42px); font-weight: 900; letter-spacing: -.03em; }
.home-redesign-category-select { position: absolute; right: 2.5%; width: 35%; }
.home-redesign-category-select > img:first-child { display: block; width: 100%; }
.home-redesign-category-select em { position: absolute; top: 50%; left: 9%; right: 23%; overflow: hidden; transform: translateY(-50%); color: #ffe772; font-size: clamp(13px, 3.7vw, 26px); font-style: normal; line-height: 1; text-align: center; text-overflow: ellipsis; white-space: nowrap; }
.home-redesign-category-select .home-redesign-category-arrow { position: absolute; top: 50%; right: 3%; width: 24%; transform: translateY(-50%); }

.home-redesign-cards { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 18px; margin-top: 27px; }
.home-redesign-card { position: relative; display: block; min-width: 0; overflow: hidden; border-radius: 28px; }
.home-redesign-card-art { display: block; width: 100%; }
.home-redesign-card-copy { position: absolute; right: 3%; bottom: 2%; left: 3%; display: block; height: 42%; }
.home-redesign-card-copy > img { display: block; width: 100%; height: 100%; }
.home-redesign-card-copy strong,
.home-redesign-card-copy em { position: absolute; left: 8%; right: 8%; text-align: center; }
.home-redesign-card-copy strong { top: 18%; color: #fff; font-size: clamp(18px, 5.2vw, 37px); font-weight: 900; line-height: 1; letter-spacing: -.04em; text-shadow: 0 3px 3px rgba(33,0,25,.85); }
.home-redesign-card-copy em { top: 49%; color: #ffe968; font-size: clamp(13px, 3.4vw, 24px); font-style: normal; font-weight: 500; line-height: 1.15; }

.home-redesign-page.is-burmese .home-redesign-category-select { right: 1.5%; width: 42%; }
.home-redesign-page.is-burmese .home-redesign-category-select em { right: 20%; left: 4%; overflow: visible; font-size: clamp(11px, 3.1vw, 22px); font-weight: 700; line-height: .96; text-overflow: clip; white-space: normal; }
.home-redesign-page.is-burmese .home-redesign-card-copy { bottom: 3%; height: 47%; }
.home-redesign-page.is-burmese .home-redesign-card-copy strong { top: 10%; right: 5%; left: 5%; font-size: clamp(15px, 4.45vw, 32px); line-height: 1.08; letter-spacing: 0; }
.home-redesign-page.is-burmese .home-redesign-card-copy em { top: 43%; right: 5%; left: 5%; font-size: clamp(11px, 3vw, 21px); font-weight: 600; line-height: 1.4; }
.home-redesign-page.is-burmese .home-category-option-art { top: 5%; width: 64%; }
.home-redesign-page.is-burmese .home-category-option span { right: 2%; bottom: 10%; left: 2%; display: -webkit-box; overflow: visible; -webkit-box-orient: vertical; -webkit-line-clamp: 2; font-size: clamp(10px, 2.75vw, 20px); line-height: 1.02; text-overflow: clip; white-space: normal; }

.home-redesign-actions { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 18px; margin-top: 26px; }
.home-redesign-actions button { position: relative; display: block; min-width: 0; }
.home-redesign-actions img { display: block; width: 100%; }
.home-redesign-actions span { position: absolute; top: 50%; left: 50%; width: 88%; transform: translate(-50%, -50%); color: #fff; font-size: clamp(18px, 5.3vw, 38px); font-weight: 900; line-height: 1.02; letter-spacing: -.04em; text-align: center; text-shadow: 0 3px 3px rgba(45,0,26,.8); text-transform: uppercase; }

.home-redesign-nav { position: fixed; z-index: 50; bottom: 16px; left: 50%; width: calc(100% - 56px); transform: translateX(-50%); }
.home-redesign-nav-bg { display: block; width: 100%; }
.home-redesign-nav button { position: absolute; top: 8%; bottom: 10%; display: flex; width: 33.33%; flex-direction: column; align-items: center; justify-content: flex-end; gap: 1px; }
.home-redesign-nav button:nth-of-type(2) { left: 33.33%; }
.home-redesign-nav button:nth-of-type(3) { right: 0; }
.home-redesign-nav button > img:not(.home-redesign-nav-active) { position: relative; z-index: 1; width: 74px; height: 74px; object-fit: contain; }
.home-redesign-nav-active { position: absolute; z-index: 0; top: -4px; width: 82% !important; height: auto !important; max-height: none !important; object-fit: contain; }
.home-redesign-nav button.is-current > img:not(.home-redesign-nav-active) { width: 128px; height: 128px; margin-top: -74px; transform: translateY(-30px); }
.home-redesign-nav button.is-current .home-redesign-nav-active { width: 82% !important; height: auto !important; margin: 0; }
.home-redesign-nav button span { color: #fff; font-size: clamp(13px, 4.4vw, 28px); font-weight: 800; line-height: 1; text-shadow: 0 2px 4px rgba(0,0,0,.72); }
.home-redesign-nav button:not(.is-current) span { color: rgba(255,255,255,.72); }

.home-category-overlay { position: fixed; z-index: 100; inset: 0; }
.home-category-overlay-mask { position: absolute; inset: 0; background: rgba(0, 0, 0, .79); }
.home-category-panel { position: fixed; z-index: 1; left: 50%; width: calc(100% - 56px); max-width: 750px; transform: translateX(-50%); }
.home-category-panel-bg { display: block; width: 100%; }
.home-category-options { position: absolute; top: 4.5%; right: 3%; bottom: 5%; left: 3%; display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); grid-auto-rows: 48%; gap: 4% 1.5%; align-content: start; }
.home-category-option { position: relative; min-width: 0; border: 0; padding: 0; background: transparent; color: #fff; font: inherit; cursor: pointer; }
.home-category-option-bg { display: block; width: 100%; height: 100%; }
.home-category-option-art { position: absolute; top: 8%; left: 50%; width: 72%; transform: translateX(-50%); }
.home-category-option span { position: absolute; right: 5%; bottom: 10%; left: 5%; overflow: hidden; color: #fff; font-size: clamp(14px, 3.3vw, 24px); font-weight: 700; line-height: 1; text-align: center; text-overflow: ellipsis; white-space: nowrap; }
.home-category-option-selected { position: absolute; top: 2%; right: 2%; width: 22%; }

.buy-more-popup { position: fixed; z-index: 120; inset: 0; }
.buy-more-popup-mask { position: absolute; inset: 0; background: rgba(0, 0, 0, .82); }
.buy-more-popup-dialog { position: absolute; top: 12.2vh; left: 50%; width: min(calc(100% - 28px), 750px); transform: translateX(-50%); }
.buy-more-popup-header { position: relative; z-index: 2; }
.buy-more-popup-header > img { display: block; width: 100%; }
.buy-more-popup-header h2 { position: absolute; top: 68%; right: 10%; left: 10%; margin: 0; transform: translateY(-50%); color: #fff; font-size: clamp(25px, 6.6vw, 48px); font-weight: 900; line-height: 1; letter-spacing: -.035em; text-align: center; text-shadow: 0 3px 2px #942006, 0 0 8px rgba(255, 190, 35, .85); -webkit-text-stroke: 1px #9d2a06; text-transform: uppercase; white-space: nowrap; }
.buy-more-popup-card { position: relative; margin-top: -5.5%; }
.buy-more-popup-card-bg { display: block; width: 100%; }
.buy-more-popup-content { position: absolute; inset: 0; display: flex; flex-direction: column; align-items: center; padding: 12% 3.5% 7%; box-sizing: border-box; }
.buy-more-popup-content > p { width: 90%; margin: 0; color: #fff; font-size: clamp(15px, 4vw, 30px); font-weight: 500; line-height: 1.08; text-align: center; }
.buy-more-popup-content > p span { display: block; }
.buy-more-popup-content > p strong { color: #ffde00; font-weight: 800; }
.buy-more-popup-hero { display: block; width: 72%; object-fit: contain; }
.buy-more-popup-options { display: grid; width: 100%; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 1.6%; margin-top: -6%; }
.buy-more-popup-options button { position: relative; min-width: 0; overflow: hidden; border: 0; border-radius: 15px; padding: 3% 2% 6%; background: #24213e; color: #fff; cursor: pointer; font: inherit; }
.buy-more-popup-options button::before { position: absolute; inset: 0; content: ''; border: 1px solid rgba(255,255,255,.05); border-radius: inherit; background: linear-gradient(180deg, rgba(255,255,255,.08), transparent 55%); pointer-events: none; }
.buy-more-popup-options button > img:not(.buy-more-popup-option-bg) { position: relative; z-index: 1; display: block; width: 78%; margin: 0 auto; }
.buy-more-popup-option-bg { position: absolute; inset: 0; width: 100%; height: 100%; opacity: .52; object-fit: cover; }
.buy-more-popup-options span { position: relative; z-index: 1; display: block; min-height: 2.15em; margin-top: 1%; color: #fff; font-size: clamp(13px, 4vw, 30px); font-weight: 500; text-align: center; }
.buy-more-popup-balance { display: flex; align-items: center; justify-content: center; gap: 6px; margin-top: 20px; color: #ffe878; font-size: clamp(14px, 4.2vw, 30px); font-weight: 500; line-height: 1; text-align: center; }
.buy-more-popup-balance img { width: clamp(22px, 6vw, 44px); height: clamp(22px, 6vw, 44px); object-fit: contain; }
.buy-more-popup-balance strong { color: #fff; font-size: 1.05em; }
.buy-more-popup-close { display: block; width: clamp(42px, 13vw, 96px); margin: 5% auto 0; border: 0; padding: 0; background: transparent; cursor: pointer; }
.buy-more-popup-close img { display: block; width: 100%; }

@media (min-width: 760px) {
  .home-redesign-page { padding-top: 50px; }
  .home-redesign-header { min-height: 132px; }
  .home-redesign-avatar { width: 94px; height: 94px; }
  .home-redesign-stat { height: 68px; }
  .home-redesign-stat > img:first-child,
  .home-redesign-stat .home-redesign-plus { width: 48px; height: 48px; }
  .home-redesign-settings img { width: 70px; }
}

@media (max-width: 420px) {
  .home-redesign-page { padding: 28px 18px 232px; }
  .home-redesign-header { gap: 6px; min-height: 91px; }
  .home-redesign-avatar { width: 58px; height: 58px; border-width: 2px !important; }
  .home-redesign-stat { height: 43px; padding: 0 6px !important; border-width: 1px !important; }
  .home-redesign-stat > img:first-child,
  .home-redesign-stat .home-redesign-plus { width: 30px; height: 30px; }
  .home-redesign-stat strong { margin-left: 4px; }
  .home-redesign-settings img { width: 47px; }
  .home-redesign-banner { margin-top: 17px; }
  .home-redesign-cards,
  .home-redesign-actions { gap: 11px; }
  .home-redesign-card { border-radius: 21px; }
  .home-redesign-nav { bottom: 9px; width: calc(100% - 36px); }
  .home-redesign-nav button > img:not(.home-redesign-nav-active) { width: 60px; height: 60px; }
  .home-redesign-nav button.is-current > img:not(.home-redesign-nav-active) { width: 106px; height: 106px; margin-top: -60px; transform: translateY(-26px); }
  .home-category-panel { width: calc(100% - 36px); }
  .buy-more-popup-dialog { top: 10.3vh; width: calc(100% - 28px); }
  .buy-more-popup-content { padding-top: 12%; }
  .buy-more-popup-options button { border-radius: 12px; }
}

.choose-modal-content {
  position: absolute;
  top: auto;
  bottom: 0;
  transform: translate(0, 0);
  background: #f6f6f6;
  width: 100%;
  left: 0;
  min-height: 600px;
  padding: 40px
}

.choose-modal-content .title {
  color: #4c5bff;
  text-align: center;
  margin-bottom: 20px;
  font-size: 36px
}

.choose-list {
  padding: 20px 0 40px
}

.dian {
  position: absolute;
  right: 10px;
  top: 10px;
}

.active .dian {
  background: url(../../static/images/gou.png) no-repeat 0 0;
  width: 36px;
  height: 36px;
  background-size: cover;
  border: none;
}

.choose-li {
  padding: 20px 0
}

.close {
  background: rgb(255 255 255 / 20%);
  color: #fff;
  width: 100px;
  height: 100px;
  font-size: 60px;
  margin: 30px auto 0;
  border-radius: 100px;
}

.new-img {
  margin: 40px 40px 0;
  width: auto;
}

.new-img .img-b {
  width: 48%;
  border: 4px solid #0062ff;
  border-radius: 10px;
}

.img-b img {
  width: 100%;
  border-radius: 10px;
}


.marquee-box {
  height: 60px;
  overflow: hidden;
  background: #ffffffa6;
  border-radius: 10px;
  margin: 20px 40px;
  padding: 30px 20px;
}

.football-index-banner {
  margin: 18px 40px 0;
  cursor: pointer;
}

.football-index-banner img {
  display: block;
  width: 100%;
  border-radius: 16px;
}

.live-quiz-entry {
  display: flex;
  align-items: center;
  gap: 18px;
  margin: 24px 40px 0;
  padding: 17px 20px;
  border: 2px solid rgba(255, 223, 107, .62);
  border-radius: 22px;
  color: #fff;
  background: linear-gradient(135deg, rgba(64, 40, 132, .98), rgba(23, 24, 81, .98));
  box-shadow: 0 10px 26px rgba(17, 7, 58, .32);
  cursor: pointer;
}

.live-quiz-entry img {
  width: 64px;
  height: 64px;
  flex: none;
  object-fit: contain;
}

.live-quiz-entry-copy {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 5px;
}

.live-quiz-entry-copy strong {
  color: #ffe26c;
  font-size: 30px;
  line-height: 1.1;
}

.live-quiz-entry-copy span {
  overflow: hidden;
  color: rgba(255, 255, 255, .78);
  font-size: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.live-quiz-entry-arrow {
  color: #ffe26c;
  font-size: 52px;
  font-weight: 300;
  line-height: 1;
}

.marquee-list {
  display: flex;
  flex-direction: column;
  animation: scroll-marquee 20s linear infinite;
}

.marquee-item {
  height: 40px;
  line-height: 40px;
  color: #333;
  font-size: 28px;
  white-space: nowrap;
}

/* 滚动动画 */
@keyframes scroll-marquee {
  0% {
    transform: translateY(0%);
  }
  100% {
    transform: translateY(-50%);
  }
}

.announcement-popup {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 130px 28px 34px;
  box-sizing: border-box;
}

.announcement-popup-mask {
  position: absolute;
  inset: 0;
  background: rgba(28, 0, 4, 0.88);
}

.announcement-popup-dialog {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 620px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.announcement-popup-card {
  position: relative;
  width: 100%;
}

.announcement-popup-bg {
  display: block;
  width: 100%;
}

.announcement-popup-content {
  position: absolute;
  inset: 0;
}

.announcement-popup-title-wrap {
  position: absolute;
  top: -17.5%;
  left: -0.5%;
  width: 101%;
  z-index: 3;
}

.announcement-popup-title-wrap img,
.announcement-popup-copy-wrap img,
.announcement-popup-action img {
  display: block;
  width: 100%;
}

.announcement-popup-title-wrap h2 {
  position: absolute;
  top: 38%;
  left: 50%;
  width: 76%;
  margin: 0;
  transform: translate(-50%, -50%) rotate(2deg);
  color: #ffef73;
  font-family: "Arial Black", Atom-sans, sans-serif;
  font-size: clamp(28px, 5.3vw, 46px);
  line-height: 1;
  letter-spacing: -2px;
  text-align: center;
  z-index: 3;
  text-shadow:
    -3px -3px 0 #310600,
    3px -3px 0 #310600,
    -3px 3px 0 #310600,
    3px 3px 0 #310600,
    0 6px 0 #310600;
}

.announcement-popup-copy-wrap {
  position: absolute;
  top: 8.5%;
  left: 50%;
  width: 79%;
  transform: translateX(-50%);
  z-index: 2;
}

.announcement-popup-copy-wrap p {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 6% 7%;
  box-sizing: border-box;
  color: #3b0608;
  font-family: Atom-sans, Arial, sans-serif;
  font-size: clamp(19px, 3.4vw, 30px);
  line-height: 1.2;
  letter-spacing: 0;
  text-align: center;
}

.announcement-popup-prize {
  position: absolute;
  top: 39.5%;
  left: 50%;
  width: 92.5%;
  transform: translateX(-50%);
}

.announcement-popup-action {
  position: absolute;
  left: 50%;
  bottom: 3.8%;
  width: 52%;
  padding: 0;
  border: 0;
  transform: translateX(-50%);
  background: transparent;
  box-shadow: none;
}

.announcement-popup-action span {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -54%);
  color: #ffffff;
  font-family: "Arial Black", Atom-sans, sans-serif;
  font-size: clamp(26px, 5vw, 43px);
  line-height: 1;
  letter-spacing: -2px;
  white-space: nowrap;
  text-shadow:
    -3px -3px 0 #3b1505,
    3px -3px 0 #3b1505,
    -3px 3px 0 #3b1505,
    3px 3px 0 #3b1505;
}

.announcement-popup-close {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 68px;
  height: 68px;
  margin-top: 22px;
  padding: 0;
  border: 4px solid #ffffff;
  border-radius: 50%;
  background: transparent;
  color: #ffffff;
  font-family: Arial, sans-serif;
  font-size: 54px;
  font-weight: 200;
  line-height: 1;
}

@media (max-height: 900px) {
  .announcement-popup {
    padding-top: 100px;
  }

  .announcement-popup-dialog {
    max-width: min(620px, 67vh);
  }

  .announcement-popup-close {
    width: 58px;
    height: 58px;
    margin-top: 14px;
    padding: 0;
    font-size: 46px;
    line-height: 1;
  }
}

.football-popup {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
}

.football-popup-mask {
  position: absolute;
  inset: 0;
  background: rgba(14, 7, 24, 0.78);
}

.football-popup-dialog {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 760px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.football-popup-card {
  position: relative;
  width: 100%;
}

.football-popup-image {
  display: block;
  width: 100%;
  border-radius: 36px;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.35);
}

.football-popup-action {
  position: absolute;
  left: 50%;
  bottom: 36px;
  transform: translateX(-50%);
  width: 320px;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
}

.football-popup-action img {
  display: block;
  width: 100%;
}

.football-popup-close {
  width: 88px;
  height: 88px;
  margin-top: 22px;
  border: 4px solid #ffffff;
  border-radius: 50%;
  background: rgba(23, 9, 42, 0.78);
  color: #ffffff;
  font-size: 52px;
  line-height: 1;
  text-transform: lowercase;
}

  .otp-action-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 18px;
    margin-top: 24px;
  }

  .otp-action-btn {
    width: 420px !important;
    max-width: 420px !important;
    min-width: 420px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin: 0 auto;
  }

  .otp-action-btn-cancel {
    border: 2px solid #fff;
    color: #fff;
  }


</style>



// WEBPACK FOOTER //
// src/page/index.vue